import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import cfac22 from './cfac22';

const config = {
  apiKey: cfac22('FIREBASE_APIKEY'),
  authDomain: cfac22('FIREBASE_AUTHDOMAIN'),
  projectId: cfac22('FIREBASE_PROJECTID'),
  messagingSenderId: cfac22('FIREBASE_MESSAGINGSENDERID'),
  appId: cfac22('FIREBASE_APP_ID'),
  storageBucket: cfac22('FIREBASE_STORAGEBUCKET'),
};

// Initialize Firebase with the modular API
export const firebaseImpl = initializeApp(config);
export const firebaseStorage = getStorage(firebaseImpl);
